import returnButtonHelper from "../../js/content_module/returnButton";
import datumPayDialogHelper from "../../js/content_module/datumPayDialog";
window.datumPayDialogHelper = datumPayDialogHelper;
import Link from '../../common/prefixName';
import externalApp from '../../data/externalApp'
import vue_Preview from "../../common/vue-preview/dist/vue-preview.min";

// modules
import bannerModuleHelper from "../../js/content_module/banner";
import phoneBindingDrawer from "../../js/content_module/phoneBindingDrawer";

// data
import vipTypeEnum from '../../data/vipTypeEnum';

// platformApi
import storageManager from "../../lib/platformApi/storageManager";

// utils
import Utils from "../../../common/utils";
import userUtil from "../../lib/util/user";
import wechatHelper from "../../util/wechatHelper";

var userInfo = null;
var promotionCode = '';
var shareUrl = '';

app.init(appConfig);
Vue.use(vue_Preview);

// fix some link
if (location.href.indexOf('html/downloadDetail.html') >= 0) {

    // fix navbar's links
    $('.mainNavBar .menuItem a').each(function () {
        var url = $(this).attr('href');
        $(this).attr('href', url.replace('../', ''));
    });
}
else    // for html/download/detail.html
{
    $('#myVipLink').attr('href', '../' + $('#myVipLink').attr('href'));
}

returnButtonHelper.setAction(function () {

    // check parent folder, wechat pay folder only support 'html/'.
    // if (location.href.indexOf('html/download/detail.html') >= 0) {
    //     location.href = 'list.html';
    // }
    // location.href = externalApp.newShixun.baseUrl + 'index.html#/datum';

    var url = externalApp.newShixun.baseUrl + 'index.html#/learn/course';
    app.redirect(url);
});

var me = new Vue({
    el: '#mainControl',
    data: {
        id: '',
        info: {},
        adInfo: [],
        isUserVip: false,
        userVipInfo : null,
        loadingStatus: false
    },
    methods: {

        //资料返回
        back: function() {
            console.log('你好')
            window.history.back();
        },



        // call after check login
        init: function () {

            var me = this;
            var id = me.id = Utils.param().id;

            if (null == me.id || '' == me.id) {
                mui.toast("参数获取异常", {
                    duration: 'long',
                    type: 'div'
                })
                return;
            }

            //wx share log
            let code = getUrlParam('promotionCode')
            if (code) {
                $.ajax({
                    type: 'POST',
                    url: Link.prefix.realmName  + 'base/wx/jssdkconfig/transmitBrow',
                    data: {
                        id: getUrlParam('id'),
                        bizType: 'DATUM',
                        promotionCode: code
                    },
                    dataType: 'JSON',
                    success: function(res) {}
                })
            }

            // save promotion code, if from
            promotionCode = getUrlParam('promotionCode') || '';
            if (promotionCode && userInfo && promotionCode != userInfo.introduceCode) {
                $.cookie('promotion_from', promotionCode, {
                    path: '/'
                });
            }

            // set user's introduce code to url if exists.
            if (userInfo &&
                typeof (userInfo.introduceCode) != 'undefined' &&
                userInfo.introduceCode != promotionCode)
            {
                log('add introduceCode param to url.');
                var newUrl = location.href.replace(location.search, '');
                newUrl += '?id=' + id + '&promotionCode=' + userInfo.introduceCode;
                shareUrl = newUrl;

                // windows wechat has a bug: use window.history.pushState method will redirect to first url.
                if (isWindowsWechat()) {
                    location.href = shareUrl;
                    return;
                }

                setCurrentUrl(shareUrl);

                // check new url
                if (location.href.indexOf('promotionCode=' + userInfo.introduceCode) < 0) {
                    log('url no introduceCode param, redirect to ' + newUrl);
                    // if url not update, then redirect url.
                    location.href = shareUrl;
                }
            }

            this.getDetail();
            me.getAd();

            isWechat() ? setWechat() : null;
        },
        getDetail: function () {
            var me = this;
            $.ajax({
                url: Link.prefix.realmName + "/portal/datum/get",
                data: {
                    id: me.id
                },
                success: function (res) {
                    console.log(res)
                    me.info = res.data;
                    document.title = me.info.title;

                    // check show pay dialog
                    var showPayDialog = Utils.param().showPayDialog || '';
                    if (showPayDialog) {
                        me.goDown();
                    }

                    isWechat() ? setWechat() : null;
                },
                error: function (res) {}
            });
        },
        getAd: function () {
            var me = this;
            $.ajax({
                url: Link.prefix.realmName + "portal/datum/getRandomDatumList",
                data: {
                    limit: 3,
                    id : getUrlParam('id')
                },
                success: function (data) {
                    me.adInfo = data.data;
                }
            });
        },
        formatPublishedDate: function (timestamp) {
            return moment(timestamp).format('YYYY-MM-DD');
        },
        formatFileSize: function (limit) {
            var size = "";
            if (limit < 0.1 * 1024) { //如果小于0.1KB转化成B
                size = limit.toFixed(2) + "B";
            } else if (limit < 0.1 * 1024 * 1024) { //如果小于0.1MB转化成KB
                size = (limit / 1024).toFixed(2) + "KB";
            } else if (limit < 0.1 * 1024 * 1024 * 1024) { //如果小于0.1GB转化成MB
                size = (limit / (1024 * 1024)).toFixed(2) + "MB";
            } else { //其他转化成GB
                size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
            }

            var sizestr = size + "";
            var len = sizestr.indexOf("\.");
            var dec = sizestr.substr(len + 1, 2);
            if (dec == "00") { //当小数点后为00时 去掉小数部分
                return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
            }
            return sizestr;
        },
        goDown: function () {

            var me = this;
            /**
             *        | free content | VIP content | none free content
             * no VIP | chargeMode  | isPay      | isPay
             * VIP    | chargeMode  | isVip      | isPay
             */

            if (me.info.isPay) {

                if ( !phoneBindingDrawer.isBindedPhone )
                {
                    $('#phoneBindingDrawer').show();
                    // phoneBindingDrawer.visible = true;
                    return;
                }

                // check questionnaire
                let bindPhoneTime = storageManager.getItem('bindPhoneTime') || '';
                let needCheckQuestionnaire = true;
                if (bindPhoneTime)
                {
                    let date = moment(bindPhoneTime);
                    let expireTimestamp = parseFloat(date.format('x')) + appConfig.questionnaire.afterBindPhone * 60 * 1000;
                    if (expireTimestamp > new Date().getTime()) // 绑定手机N分钟内不弹出调查问卷
                    {
                        needCheckQuestionnaire = false;
                    }
                }

                if (needCheckQuestionnaire)
                {
                    //问卷调查
                    $.ajax({
                        url: Link.prefix.realmName + '/portal/questionnaire/v2/isAbleFileIn/opinionQuestionnaire',
                        success : (result) => {
                            // result.data type: Boolean
                            if(result.data) {
                                storageManager.setItem('prevPageUrl', location.href);
                                app.redirect(externalApp.newShixun.baseUrl + 'index.html#/questionnaire');
                                return;
                            }

                            app.toast("正在为您跳转下载页面。");
                            if (location.href.indexOf('html/downloadDetail.html') >= 0) {
                                window.location.href = './download/paySuccess.html?id=' + me.info.id;
                            } else {
                                window.location.href = './paySuccess.html?id=' + me.info.id;
                            }
                        },
                        error : (error) => {
                            app.ajaxErrorHandle(error);
                        }
                    });
                }
                else
                {
                    app.toast("正在为您跳转下载页面。");
                    if (location.href.indexOf('html/downloadDetail.html') >= 0) {
                        window.location.href = './download/paySuccess.html?id=' + me.info.id;
                    } else {
                        window.location.href = './paySuccess.html?id=' + me.info.id;
                    }
                }

                return;
            }
            /**
             * 加V 且用户是 VIP  或 Free
             */
            if ((me.isUserVip && me.info.isV) || !me.info.chargeMode) {
                $.ajax({
                    url: Link.prefix.realmName + "portal/datum/pay_free_datum",
                    data: {
                        id: me.info.id
                    },
                    success: function (data) {
                        if (data.errorCode != 0) {
                            app.toast(data.msg);
                            return;
                        }
                        if ( !phoneBindingDrawer.isBindedPhone )
                        {
                            $('#phoneBindingDrawer').show();
                            // phoneBindingDrawer.visible = true;
                            return;
                        }

                        if (location.href.indexOf('html/downloadDetail.html') >= 0) {
                            window.location.href = './download/paySuccess.html?id=' + me.info.id
                        }
                        else
                        {
                            window.location.href = './paySuccess.html?id=' + me.info.id;
                        }
                    },
                    error : app.config.ajaxErrorHandle
                })
            } else {
                // check parent folder, wechat pay folder only support 'html/'.
                if (location.href.indexOf('html/download/detail.html') >= 0) {
                    location.href = '../downloadDetail.html?id=' + me.id + '&showPayDialog=1';
                }
                datumPayDialogHelper.setProduct({
                    id : this.info.id,
                    title : this.info.title,
                    image : this.info.coverImg,
                    price : this.info.price,
                });
                datumPayDialogHelper.open();
                // mui.toast("您尚未支付,正在为您跳转支付", {duration: 'long', type: 'div'})
                // location.href="../download-pay.html?id="+me.id;
            }

        },
        goListPage: function () {
            location.href = '//yj.shixun365.com/shixun-mobile-2020/index.html#/datum'
        },
        initSwiper: function () {
            var mySwiper = new Swiper('.previewSwiper', {
                slidesPerView: 2,
                on: {
                    init: function () {
                        swiperAnimateCache(this); //隐藏动画元素
                        this.emit('slideChangeTransitionEnd'); //在初始化时触发一次slideChangeTransitionEnd事件
                    },
                    slideChangeTransitionEnd: function () {
                        swiperAnimate(this); //每个slide切换结束时运行当前slide动画
                        this.slides.eq(this.activeIndex).find('.ani').removeClass('ani'); //动画只展示一次
                    }
                },
                pagination: {
                    el: '.swiper-pagination',
                },
                autoplay: true,
                zoom: true,
                slideToClickedSlide: true,
                centeredSlides: true,
                // slidesPerView: 3
            });
        }
    },
    created() {
        // this.init();
    },
    updated() {
        // console.log('vue updated');
        if ($('.previewSwiper .swiper-slide').length) {
            // addConsoleLog('[info] has swiper item.');
            this.initSwiper();
        }
        // else
        // {
        //     // addConsoleLog('[info] no any swiper item.');
        // }
    }
});

var search = new Vue({
    el: '#indexSearch',
    data() {
        return {
            indexFlag: false,
            searchContent: '',
            searchResultList: [],
            searchHistoryList: [],
        }
    },
    methods: {
        onSearch() {
            this.indexFlag = true
        },
        openUrl: function(id, url){
            $.ajax({
                url: Link.prefix.realmName + "/portal/advertis/click",
                data: {
                    id: id
                },
                success: function (result) {},
                error: function (result) {
                },
                complete: function() {
                    //set Session Key
                    setSessionData('ad_sessino_key',id);
                    location.href=url;
                }
            });
        },
        cancel() {
            this.indexFlag = false
            this.searchContent = ''
        },
        getSearch(searchStr) {
            if (searchStr == '' || searchStr == null || searchStr.indexOf(' ') != -1) {
                return
            } else {
                var listURL = '//yj.shixun365.com/shixun-mobile-2020/index.html#/datum'
                window.location.href = listURL + searchStr
            }
        },
        getSearchHistory() {
            var that = this
            $.ajax({
                type: "GET",
                url: Link.prefix.realmName + "portal/home/getUserKeywordHistory",
                data: {
                    limit: 12,
                    type: "DATUM"
                },
                dataType: "JSON",
                success: function (res) {
                    that.searchHistoryList = res.data
                },
                error: function (err) {
                    throw err
                }
            });
        },
        searchThis(keyword) {
            this.getSearch(keyword)
        }
    },
    created() {
        // this.getSearchHistory();

        // append banner module, must set a unique ID.
        $(bannerModuleHelper.element).attr('id', 'datum_detail_banner_1');
        $('#position_2').append(bannerModuleHelper.element);
        bannerModuleHelper.init();
        bannerModuleHelper.loadData({
            typeEnum: 'DATUM_DETAIL'
        }, {
            id : getUrlParam('id')
        });
    },
    mounted() {
        new Swiper('.navbarSwiper', appConfig.swiperOptions);
    }
})

Link.verifyLoin(
    function (user) {

        if (typeof (user) == 'object' && user)
        {
            userInfo = userUtil.createUser(user);
            // me.isUserVip = !!user.isVip;
            me.isUserVip = userInfo.isContentHasVipPrivilege('datum');

            if (typeof (user.vipDueTime) === 'object')
            {
                me.userVipInfo = {};
                me.userVipInfo.datum = {
                    dueTime : user.vipDueTime[vipTypeEnum.DATUM]
                };
                me.userVipInfo.courseVod = {
                    dueTime : user.vipDueTime[vipTypeEnum.COURSE_VOD]
                };
                me.userVipInfo.super = {
                    dueTime : user.vipDueTime[vipTypeEnum.SUPER]
                };
            }
        }
        me.init();
    }
);

/* set wechat, after loaded list data*/
var setWechat = (function () {
    app.loadWechatJSSDKConfig({
        jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline',
            'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone',
            'updateAppMessageShareData', 'updateTimelineShareData',
            'chooseWXPay'
        ],
        onReady: function () {
            log('wechat JSSDK ready.');
            setWechatShare ? setWechatShare() : null;
        },
        onError: function () {
            addConsoleLog('[error] wechat JSSDK config error.');
        }
    });
});

/* set wechat share. */
var setWechatShare = (function () {

    var wechatShareOptions = {
        title: document.title, // 分享标题
        desc: me.info ? me.info.introduction || document.title : document.title,
        link: shareUrl || location.href,
        imgUrl: (me.info && me.info.imgList) ? me.info.imgList[0] : getPageIcon(), // 分享图标
        success: function () {
            //成功之后的回调
            log('set wechat share success.');
        },
        fail: function () {
            log('set wechat share failed.');
        },
        cancel: function () {
            log('share canceled.');
        }
    };

    wechatHelper.setShare(wechatShareOptions);
});

phoneBindingDrawer.onBindSuccess = () => {
    location.reload();
}



/** WEBPACK FOOTER **
 ** D:/app project/shixun-web/src/shixun-mobile/js/download/detail.js
 **/